<!-- 我的购物车 -->
<template>
  <div class="shoppingCart">
    <!-- 购物车头部 -->
    <div class="cart-header">
      <div class="header-inner">
        <h1 class="cart-title">
          <i class="el-icon-shopping-cart-full"></i>
          我的购物车
        </h1>
        <p class="cart-tips">温馨提示：产品是否购买成功，以最终下单为准哦，请尽快结算</p>
      </div>
    </div>
    <!-- 购物车头部END -->

    <!-- 购物车主要内容区 -->
    <div class="main-content" v-if="getShoppingCart.length > 0" v-loading="loading">
      <div class="cart-table">
        <!-- 购物车表头 -->
        <div class="table-header">
          <div class="col-check">
            <el-checkbox v-model="isAllCheck" class="custom-checkbox">全选</el-checkbox>
          </div>
          <div class="col-product">商品信息</div>
          <div class="col-price">单价</div>
          <div class="col-quantity">数量</div>
          <div class="col-subtotal">小计</div>
          <div class="col-actions">操作</div>
        </div>
        <!-- 购物车表头END -->

        <!-- 购物车列表 -->
        <div class="table-body">
          <div class="table-row" v-for="(item, index) in getShoppingCart" :key="item.id">
            <div class="col-check">
              <el-checkbox :value="item.check" @change="checkChange($event, index)" class="custom-checkbox"></el-checkbox>
            </div>
            <div class="col-product">
              <div class="product-item">
                <div class="product-thumb">
                  <router-link :to="{ path: '/detail', query: { id: item.goods_id } }">
                    <img :src="item.thumbnail" />
                  </router-link>
                </div>
                <div class="product-info">
                  <router-link :to="{ path: '/detail', query: { id: item.goods_id } }" class="product-name">
                    颜色: {{ item.color }}, 尺寸: {{ item.size }}, 重量: {{ item.weight }}
                  </router-link>
                  <div class="product-specs">
                    SKU: {{ item.goods_sn }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-price">¥{{ item.price }}</div>
            <div class="col-quantity">
              <el-input-number size="small" :value="item.goods_num" @change="handleChangeNum($event, index, item.goods_sn)" :min="1" class="quantity-input"></el-input-number>
            </div>
            <div class="col-subtotal">¥{{ (item.price * item.goods_num).toFixed(2) }}</div>
            <div class="col-actions">
              <el-popover placement="top" trigger="click">
                <p>确定删除吗？</p>
                <div class="popover-buttons">
                  <el-button size="mini" @click="$refs.popover && $refs.popover.doClose()">取消</el-button>
                  <el-button type="danger" size="mini" @click="deleteItem($event, item.goods_sn)">确定</el-button>
                </div>
                <i class="el-icon-delete" slot="reference" style="cursor: pointer; font-size: 18px; color: #999;"></i>
              </el-popover>
            </div>
          </div>
        </div>
        <!-- 购物车列表END -->
      </div>

      <!-- 购物车底部导航条 -->
      <div class="cart-footer">
        <div class="footer-actions">
          <div class="select-info">
            <router-link to="/df" class="continue-shopping">继续购物</router-link>
            <span class="sep">|</span>
            <span class="item-count">
              共 <span class="count-num">{{ getCartTotalCount }}</span> 条商品，已选择 <span class="count-num">{{ getCheckNum }}</span> 件
            </span>
          </div>
          <div class="checkout-info">
            <div class="total">
              <span class="total-label">合计：</span>
              <span class="total-amount">¥{{ getTotalPrice }}</span>
            </div>
            <el-button :disabled="getCheckNum <= 0" @click="addOrder" class="checkout-btn">
              去结算
            </el-button>
          </div>
        </div>
      </div>
      <!-- 购物车底部导航条END -->

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          layout="prev, pager, next, total, jumper"
          :total="totalCount"
          :page-size="query.pageSize"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 购物车主要内容区END -->

    <!-- 购物车为空的时候显示的内容 -->
    <div v-else class="cart-empty">
      <div class="empty-content">
        <img src="../assets/imgs/cart-empty.png" alt="购物车空" class="empty-img" />
        <h2>您的购物车还是空的！</h2>
        <p>快去挑选心仪的商品吧</p>
        <router-link to="/" class="go-shopping-btn">去首页逛逛</router-link>
      </div>
    </div>
    <!-- 购物车为空的时候显示的内容END -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

export default {
  name: 'Cart',
  data() {
    return {
      loading: false, // 加载状态
      totalCount: 0, // 购物车商品总条数
      query: {
        page: 1, // 当前页码
        pageSize: 50, 
      },
    };
  },
  activated() {
    // keep-alive 缓存下，每次进入购物车页面重新拉取当前页数据
    this.getCartList();
  },
  methods: {
    ...mapActions(["updateShoppingCart", "deleteShoppingCart", "checkAll", "setShoppingCart", "setCartTotalCount"]),
    /**
     * 分页获取购物车数据
     */
    async getCartList() {
      if (!this.$store.getters.getUser) {
        this.setShoppingCart([]);
        this.setCartTotalCount(0);
        return;
      }
      this.loading = true;
      try {
        const { data } = await this.$axios.post(
          this.$newApi + "/api/rbh/cart/list",
          {
            uid: this.$store.getters.getUser.id,
            page: this.query.page,
          }
        );
        // 兼容接口返回格式：数组（旧格式）或 { list, totalCount }（分页格式）
        const res = data.data
        const list = res.list
        this.totalCount = res.totalCount || 0
        // 删除商品后当前页可能为空，自动回退到上一页
        if (list.length === 0 && this.query.page > 1 && this.totalCount > 0) {
          this.query.page -= 1;
          return this.getCartList();
        }
        const cartList = list.map((item) => {
          let cart = item.goods_info;
          cart.check = false;
          return cart;
        });
        this.setShoppingCart(cartList);
        // 同步购物车总条数，供顶部角标展示
        this.setCartTotalCount(this.totalCount);
      } catch (e) {
        this.notifyError("购物车数据加载失败!");
      } finally {
        this.loading = false;
      }
    },
    /**
     * 变更页码
     * @param {*} page
     */
    currentChange(page) {
      this.query.page = page;
      this.getCartList();
    },
    /**
     * 修改商品数量
     */
    async handleChangeNum(currentValue, key, goods_sn) {
      // 当修改数量时，默认勾选
      this.updateShoppingCart({ key: key, prop: "check", val: true });
      await this.$axios.post(this.$newApi + "/api/rbh/cart/num", {
        uid: this.$store.getters.getUser.id,
        goods_sn: goods_sn,
        goods_num: currentValue,
      });
      this.updateShoppingCart({
        key: key,
        prop: "goods_num",
        val: currentValue,
      });
    },
    /**
     * 单个勾选
     * @param {*} val
     * @param {*} key
     */
    checkChange(val, key) {
      this.updateShoppingCart({ key: key, prop: "check", val: val });
    },
    /**
     * 删除购物车商品
     * @param {*} e
     * @param {*} goods_sn
     */
    async deleteItem(e, goods_sn) {
      await this.$axios.post(
        this.$newApi + "/api/rbh/cart/delete",
        {
          uid: this.$store.getters.getUser.id,
          goods_sn: goods_sn,
        }
      )
      this.deleteShoppingCart(goods_sn)
      this.notifySucceed('删除成功!')
      // 重新拉取当前页，保持分页总数与后端一致
      this.getCartList()
    },
    /**
     * 确认下单
     */
    addOrder() {
      if (!this.$store.getters.getUser) {
        this.$store.dispatch("setShowLogin", true);
        return;
      }
      const orderData = this.getShoppingCart.filter((item) => {
        return item.check === true
      })
      const order_no = Date.now().toString() + Math.floor(Math.random() * 100).toString()
      localStorage.setItem("orderGoods" + order_no, JSON.stringify(orderData.map((item) => {
        item.num = item.goods_num
        return item
      })))
      const newRouter = this.$router.resolve( { path: '/confirmOrder', query: { order_no : order_no}})
      window.open(newRouter.href, '_blank')
    },
  },
  computed: {
    ...mapGetters([
      "getShoppingCart",
      "getCheckNum",
      "getTotalPrice",
      "getCartTotalCount",
    ]),
    isAllCheck: {
      get() {
        return this.$store.getters.getIsAllCheck;
      },
      set(val) {
        this.checkAll(val);
      },
    },
  },
};
</script>


<style scoped>
.shoppingCart {
  background-color: #f5f7fa;
  padding-bottom: 20px;
  min-height: 100vh;
}

/* 购物车头部 */
.cart-header {
  background: #fff;
  border-bottom: 2px solid #ff6b6b;
  padding: 20px 0;
  margin-bottom: 20px;
}

.header-inner {
  width: 1240px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.cart-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 24px;
  color: #333;
  margin: 0;
  font-weight: 600;
}

.cart-title i {
  color: #ff6b6b;
  font-size: 28px;
}

.cart-tips {
  color: #999;
  font-size: 14px;
  margin: 0;
}

/* 购物车主要内容区 */
.main-content {
  width: 1240px;
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

/* 购物车表格 */
.cart-table {
  width: 100%;
}

.table-header {
  display: flex;
  align-items: center;
  height: 50px;
  background: #f8f9fa;
  border-bottom: 1px solid #eee;
  padding: 0 20px;
  font-weight: 600;
  color: #666;
}

.col-check {
  width: 80px;
  display: flex;
  align-items: center;
}

.col-product {
  flex: 1;
  padding-left: 20px;
}

.col-price {
  width: 120px;
  text-align: center;
}

.col-quantity {
  width: 120px;
  text-align: center;
}

.col-subtotal {
  width: 120px;
  text-align: right;
  padding-right: 20px;
}

.col-actions {
  width: 80px;
  text-align: center;
}

/* 表格行 */
.table-row {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.3s;
}

.table-row:hover {
  background-color: #fcfcfc;
}

.product-item {
  display: flex;
  align-items: center;
  gap: 12px;
}

.product-thumb {
  width: 60px;
  height: 60px;
  border: 1px solid #eee;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.product-info {
  flex: 1;
}

.product-name {
  display: block;
  color: #333;
  font-size: 13px;
  margin-bottom: 3px;
  line-height: 1.4;
}

.product-name:hover {
  color: #ff6b6b;
}

.product-specs {
  color: #999;
  font-size: 11px;
}

.quantity-input ::v-deep .el-input-number__decrease,
.quantity-input ::v-deep .el-input-number__increase {
  border-color: #ddd;
  background: #f8f9fa;
  width: 28px;
}

.quantity-input ::v-deep .el-input-number__decrease:hover,
.quantity-input ::v-deep .el-input-number__increase:hover {
  background: #f0f0f0;
}

.quantity-input ::v-deep .el-input__inner {
  padding: 0 5px;
  width: 40px;
  height: 28px;
}

/* 自定义复选框样式 */
.custom-checkbox ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #ff6b6b;
  border-color: #ff6b6b;
}

.custom-checkbox ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ff6b6b;
}

/* 购物车底部导航条 */
.cart-footer {
  background: #fff;
  border-top: 1px solid #eee;
  padding: 0 20px;
}

.footer-actions {
  width: 1240px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
}

.select-info {
  display: flex;
  align-items: center;
  gap: 15px;
}

.continue-shopping {
  color: #666;
  font-size: 14px;
}

.continue-shopping:hover {
  color: #ff6b6b;
}

.sep {
  color: #ccc;
}

.item-count {
  color: #999;
  font-size: 14px;
}

.count-num {
  color: #ff6b6b;
  font-weight: 600;
}

.checkout-info {
  display: flex;
  align-items: center;
  gap: 20px;
}

.total {
  display: flex;
  align-items: center;
  gap: 5px;
}

.total-label {
  color: #999;
  font-size: 14px;
}

.total-amount {
  color: #ff6b6b;
  font-size: 24px;
  font-weight: 600;
}

.checkout-btn {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  border: none;
  color: #fff;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;
  margin-right: 30px; /* 添加右侧空白 */
}

.checkout-btn:hover:not(.is-disabled) {
  background: linear-gradient(135deg, #ff5252 0%, #e54545 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
}

.checkout-btn.is-disabled {
  background: #e0e0e0;
  cursor: not-allowed;
}

/* 购物车为空 */
.cart-empty {
  width: 1240px;
  margin: 0 auto;
  text-align: center;
  padding: 60px 0;
}

.empty-content {
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.empty-img {
  width: 150px;
  height: 150px;
  margin-bottom: 20px;
}

.empty-content h2 {
  color: #333;
  font-size: 24px;
  margin: 0 0 10px;
}

.empty-content p {
  color: #999;
  font-size: 16px;
  margin: 0 0 20px;
}

.go-shopping-btn {
  display: inline-block;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: #fff;
  padding: 10px 20px;
  border-radius: 6px;
  text-decoration: none;
  font-size: 14px;
  transition: all 0.3s;
}

.go-shopping-btn:hover {
  background: linear-gradient(135deg, #ff5252 0%, #e54545 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(255, 107, 107, 0.3);
}

/* 弹窗按钮 */
.popover-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
}

/* 分页 */
.pagination-container {
  text-align: center;
  padding: 20px 0;
}

.pagination-container ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ff6b6b;
  color: #fff;
}

.pagination-container ::v-deep .el-pagination.is-background .btn-next,
.pagination-container ::v-deep .el-pagination.is-background .btn-prev,
.pagination-container ::v-deep .el-pagination.is-background .el-pager li {
  background: #f8f9fa;
}

.pagination-container ::v-deep .el-pagination.is-background .btn-next:hover,
.pagination-container ::v-deep .el-pagination.is-background .btn-prev:hover,
.pagination-container ::v-deep .el-pagination.is-background .el-pager li:hover {
  color: #ff6b6b;
}
</style>